module.exports = __webpack_public_path__ + "static/media/EnergySmartSlide03.d6dcf7ad.jpg";